import script from "./PortfolioGridItem.vue?vue&type=script&setup=true&lang=js"
export * from "./PortfolioGridItem.vue?vue&type=script&setup=true&lang=js"

import "./PortfolioGridItem.vue?vue&type=style&index=0&id=a528993c&lang=css"

const __exports__ = script;

export default __exports__